import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Flex,
  SimpleGrid,
  Button,
  useColorModeValue,
  VStack
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const HowItWorks = () => {
  const bgGradient = useColorModeValue('white', 'gray.800');

  const borderColor = useColorModeValue('gray.200', 'gray.600');
  
  const steps = [
    {
      emoji: "📋",
      title: "Create Your MommaFuel",
      description: "Enter your due date and contact information",
    },
    {
      emoji: "🍽️",
      title: "Set Preferences",
      description: "Share your favorite types of cuisine and drop off information",
    },
    {
      emoji: "👥",
      title: "Share Link",
      description: "Share your MommaFuel link with friends and family",
    },
    {
      emoji: "📅",
      title: "Baby Arrives",
      description: "When you know you're returning home, open the meal slots",
    },
    {
      emoji: "🔔",
      title: "Friends Schedule Meals",
      description: "Friends sign up for meal drop off days convenient for them",
    },
    {
      emoji: "🍲",
      title: "Receive Meals",
      description: "Enjoy delicious support from friends and family",
    }
  ];

  return (
    <Box 
      bgGradient={bgGradient} 
      minH={{ base: "auto", lg: "calc(100vh - 60px)" }}
      py={{ base: 6, md: 8 }} 
      px={{ base: 0, md: 0 }} 
      display="flex" 
      alignItems="center"
    >
      <Container maxW="container.xl" flex="1">
        <VStack spacing={6} justify="center" minH={{ base: "auto", lg: "60vh" }}>
          <Heading 
            as="h1" 
            size="lg" 
            fontWeight="bold"
            textAlign="center"
          >
            How It Works
          </Heading>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} width="100%" px={4}>
            {steps.map((step, index) => (
              <Box
                key={index}
                p={5}
                borderWidth="1px"
                borderColor={borderColor}
                borderRadius="lg"
                shadow="md"
                bg="white"
                position="relative"
              >
                <Flex alignItems="center">
                  <Text fontSize="2.8rem" lineHeight="1" mr={5}>
                    {step.emoji}
                  </Text>
                  <Box>
                    <Heading as="h3" size="md" mb={2} textAlign="left">
                      {index + 1}. {step.title}
                    </Heading>
                    <Text fontSize="md" textAlign="left">{step.description}</Text>
                  </Box>
                </Flex>
              </Box>
            ))}
          </SimpleGrid>

          <Button
            as={RouterLink}
            to="/register"
            size="lg"
            colorScheme="blue"
            mt={2}
          >
            Create Your MommaFuel
          </Button>
        </VStack>
      </Container>
    </Box>
  );
};

export default HowItWorks; 